import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import configData from "../../config.json";

const Pricingdetails = ({
  isAtTop,
  pricingparacontent,
  imgrad,
  pricecherishcare,
  headerRef,
  packageDetails,
  subbtn,
  handlePayment,
  sharebtn,
  handleShare,
  democlass,
  month,
  monthno,
  monthhead,
  selectedValue, // Selected Area ID
  selectedWeek,
  pricselectedMonth,
  selectedSonographyOptions,
  discountedPrice,
  couponCode,
  setCouponCode,
  couponApplied,
  couponError,
  finalAmount,
  applyCoupon,
  setCouponError,
  couponMessage,
  setCouponMessage,

}) => {
  const [doctorList, setDoctorList] = useState({});
  const [expanded, setExpanded] = useState({});// toggle the visibility of doctors under each category
  const [activeScheduleMonth, setActiveScheduleMonth] = useState(0);
  const hasFetched = useRef(false); // Prevents duplicate API calls
  const scheduleRowRef = useRef(null);
  const scheduleTabsRef = useRef(null);
  const scheduleAutoIndexRef = useRef(0);
  // const [couponError, setCouponError] = useState(false);

  // Scroll to the top when the component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Function to toggle the visibility of doctors under each category
  const toggleExpand = (expertName) => {
    setExpanded((prev) => ({
      ...prev,
      [expertName]: !prev[expertName],
    }));
  };
  // Function to toggle the visibility of doctors under each category (ENDS)

  // Fetch doctor data when selectedValue changes
  useEffect(() => {
    const fetchDoctorList = async () => {
      if (!selectedValue || hasFetched.current) return; // Prevent duplicate fetch
      hasFetched.current = true; // Mark as fetched

      try {
        const response = await axios.post(
          `${configData.SERVER_API_URL}/common/get_doctor_list_by_id`,
          {
            area_id: Number(selectedValue),
          }
        );

        console.log("Full API Response:", response.data);

        if (response.data.success) {
          console.log("Doctor List Data:", response.data.Doctor_list);

          // If no doctors found, return early
          if (!response.data.Doctor_list || response.data.Doctor_list.length === 0) {
            console.warn("No doctors found in response.");
            return;
          }

          // Group doctors by medical_expert_name
          const groupedDoctors = response.data.Doctor_list.reduce((acc, doctor) => {
            if (!acc[doctor.medical_expert_name]) {
              acc[doctor.medical_expert_name] = [];
            }
            acc[doctor.medical_expert_name].push({
              user_name: doctor.user_name,
              education: doctor.education_name,
              experience: doctor.experience,
            });
            return acc;
          }, {});

          // Ensure "Meditation Expert" has the same doctors as "Yoga Expert"
          if (groupedDoctors["Yoga Expert"]) {
            groupedDoctors["Meditation Expert"] = groupedDoctors["Yoga Expert"];
          }

          console.log("Grouped Doctors:", groupedDoctors);
          setDoctorList(groupedDoctors);
        } else {
          console.error("API returned an error:", response.data);
        }
      } catch (error) {
        console.error("Error fetching doctor details:", error);
      }
    };

    fetchDoctorList();
  }, [selectedValue]);

  const aboutFeatures = [
    {
      icon: "/i1.jpg",
      title: "10 Medical Specialists",
      description: "Comprehensive team of experts for every aspect of your pregnancy",
    },
    {
      icon: "/i2.jpg",
      title: "44 Clinic & Online Consults",
      description: "Regular check-ups both in-person and virtual for your convenience",
    },
    {
      icon: "/i3.jpg",
      title: "40 Lab Tests (Blood & DNA)",
      description: "Comprehensive testing to monitor your health throughout pregnancy",
    },
    {
      icon: "/i5babyind.jpg",
      title: "09 Ultrasound Scans",
      description: "Regular imaging to track your baby's growth and development",
    },
    {
      icon: "/i1.jpg",
      title: "117 Yoga Sessions",
      description: "Guided movement sessions to support flexibility, strength, and calm",
    },
    {
      icon: "/i1.jpg",
      title: "18 Meditation Sessions",
      description: "Mindfulness support designed to reduce stress during pregnancy",
    },
    {
      icon: "/i6babycap.jpg",
      title: "Garbhasanskar Access",
      description: "Nine months of guided learning and rituals for a deeper care journey",
    },
    {
      icon: "/i7watch.jpg",
      title: "Daily Health Tracking",
      description: "Ongoing monitoring so your care stays proactive, not reactive",
    },
    {
      icon: "/i824x7.jpg",
      title: "24/7 Emergency Support",
      description: "Timely access to support whenever an urgent concern comes up",
    },
    {
      icon: "/i1.jpg",
      title: "Pregnancy Education",
      description: "Clear guidance to help you understand each stage with confidence",
    },
    {
      icon: "/i9pregnantlady.jpg",
      title: "Pregnancy Care Kit",
      description: "Essential products curated to support comfort and everyday wellbeing",
    },
    {
      icon: "/i10gift.jpg",
      title: "Monthly Giveaway Basket",
      description: "Premium monthly extras that make the journey feel more cherished",
    },
    {
      icon: "/i11.jpg",
      title: "Care Dashboard Transparency",
      description: "A complete view of reports, milestones, and your care progress in one place",
    },
  ];

  const scheduleMonths = [
    "7 Diagnostic lab tests, 1 Sonography, 1 Gynecologist consultation, 1 General Physician consultation, 1 Dietitian consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Gynecologist consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Gynecologist consultation, 1 General Physician consultation, 1 Dietitian consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "5 Diagnostic lab tests, 2 Sonography, 2 Gynecologist consultation, 2 General Physician consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Sonography, 1 Gynecologist consultation, 1 Dietitian consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Sonography, 1 Gynecologist consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "4 Diagnostic lab tests, 1 Sonography, 2 Gynecologist consultation, 2 General Physician consultation, 1 Dietitian consultation, 1 Psychiatrist consultation, 1 Pediatrician consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "2 Gynecologist consultation, 1 General Physician consultation, 1 Psychiatrist consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Diagnostic lab tests, 2 Sonography, 3 Gynecologist consultation, 3 General Physician consultation, 1 Dietitian consultation, 1 Psychiatrist consultation, 1 Pediatrician consultation, 13 Yoga sessions, and 2 Meditation sessions.",
    "1 Sonography, 1 Gynecologist consultation, 1 General Physician consultation",
  ];

  useEffect(() => {
    const node = scheduleRowRef.current;
    let isPaused = false;

    if (!node) {
      return undefined;
    }

    const syncActiveCard = () => {
      const cards = Array.from(node.querySelectorAll(".pricing-details-schedule-card-wrapper"));
      if (cards.length === 0) return;

      const containerLeft = node.getBoundingClientRect().left;
      let closestIndex = 0;
      let closestDistance = Number.POSITIVE_INFINITY;

      cards.forEach((card, index) => {
        const distance = Math.abs(card.getBoundingClientRect().left - containerLeft);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      scheduleAutoIndexRef.current = closestIndex;
      setActiveScheduleMonth(closestIndex);
    };

    const autoSlide = () => {
      const cards = Array.from(node.querySelectorAll(".pricing-details-schedule-card-wrapper"));
      if (isPaused || cards.length === 0) {
        return;
      }

      scheduleAutoIndexRef.current =
        (scheduleAutoIndexRef.current + 1) % cards.length;

      setActiveScheduleMonth(scheduleAutoIndexRef.current);
      node.scrollTo({
        left: cards[scheduleAutoIndexRef.current].offsetLeft,
        behavior: "smooth",
      });
    };

    const pauseSlider = () => {
      isPaused = true;
    };

    const resumeSlider = () => {
      isPaused = false;
      syncActiveCard();
    };

    node.addEventListener("scroll", syncActiveCard, { passive: true });
    node.addEventListener("touchstart", pauseSlider, { passive: true });
    node.addEventListener("touchend", resumeSlider);
    node.addEventListener("touchcancel", resumeSlider);
    node.addEventListener("mouseenter", pauseSlider);
    node.addEventListener("mouseleave", resumeSlider);
    node.addEventListener("pointerdown", pauseSlider);
    node.addEventListener("pointerup", resumeSlider);
    node.addEventListener("pointercancel", resumeSlider);

    const intervalId = window.setInterval(autoSlide, 3000);
    syncActiveCard();

    return () => {
      window.clearInterval(intervalId);
      node.removeEventListener("scroll", syncActiveCard);
      node.removeEventListener("touchstart", pauseSlider);
      node.removeEventListener("touchend", resumeSlider);
      node.removeEventListener("touchcancel", resumeSlider);
      node.removeEventListener("mouseenter", pauseSlider);
      node.removeEventListener("mouseleave", resumeSlider);
      node.removeEventListener("pointerdown", pauseSlider);
      node.removeEventListener("pointerup", resumeSlider);
      node.removeEventListener("pointercancel", resumeSlider);
    };
  }, []);

  useEffect(() => {
    const tabsNode = scheduleTabsRef.current;
    const activeTab = tabsNode?.querySelector(".pricing-details-schedule-tab--active");

    if (!tabsNode || !activeTab) {
      return;
    }

    const targetLeft =
      activeTab.offsetLeft - tabsNode.clientWidth / 2 + activeTab.clientWidth / 2;

    tabsNode.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: "smooth",
    });
  }, [activeScheduleMonth]);

  const handleScheduleMonthClick = (index) => {
    const node = scheduleRowRef.current;
    const cards = node?.querySelectorAll(".pricing-details-schedule-card-wrapper");
    if (!node || !cards?.[index]) return;

    scheduleAutoIndexRef.current = index;
    setActiveScheduleMonth(index);
    node.scrollTo({
      left: cards[index].offsetLeft,
      behavior: "smooth",
    });
  };

  const handleSubscribeScroll = () => {
    const heroNode = document.getElementById("myHeader");

    if (heroNode) {
      heroNode.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  return (
    <>
      <div className="pricing-details-page">
        <div className="pricing-details-hero">
          <div
            id="myHeader"
            className="pricing-details-shell"
          >
            <div
              className="pricing-details-card"
            >
              <div className="row align-items-center pricing-details-card__hero">
                <div className="col-12 col-lg-6">
                  <div className="pricing-details-copy">
                    <h1 className="pricing-details-copy__title">Cherish Care</h1>
                    <p className="pricing-details-copy__text">
                      Finding the right pregnancy care that is not heavy on your
                      pocket is more like a task. To reduce your burden we help
                      anytime anyday with the <strong>best all inclusive pregnancy care at
                        an affordable rate.</strong>
                    </p>
                  </div>
                </div>
                <div className="col-12 col-lg-5 ms-lg-auto">
                  <div className="pricing-details-purchase">
                    <div className="pricing-details-purchase__badge">Most Popular</div>
                    <div className="pricing-details-purchase__price-wrap">
                      <h2 className="pricing-details-purchase__price">
                        ₹{Math.round(finalAmount / 9).toLocaleString()}
                        <span className="pricing-details-purchase__price-period">/ month</span>
                      </h2>
                      <p className="pricing-details-purchase__total">
                        Total: ₹{finalAmount.toLocaleString()}
                      </p>
                    </div>

                    <div className="pricing-details-purchase__divider"></div>

                    <div className="pricing-details-purchase__coupon-row">
                      <input
                        type="text"
                        placeholder="Enter coupon code"
                        value={couponCode}
                        onChange={(e) => {
                          setCouponCode(e.target.value);
                          setCouponError(false);
                          setCouponMessage("");
                        }}
                        disabled={couponApplied}
                        className={`pricing-details-purchase__coupon-input ${couponApplied ? "pricing-details-purchase__coupon-input--applied" : ""
                          }`}
                      />
                      <button
                        onClick={applyCoupon}
                        disabled={couponApplied}
                        className={`pricing-details-purchase__coupon-button ${couponApplied ? "pricing-details-purchase__coupon-button--applied" : ""
                          }`}
                      >
                        {couponApplied ? "Applied" : "Apply"}
                      </button>
                    </div>

                    <div className="pricing-details-purchase__message">
                      {couponApplied && (
                        <p className="pricing-details-purchase__message-text pricing-details-purchase__message-text--success">
                          Coupon applied. Your new price: ₹{finalAmount?.toLocaleString()}
                        </p>
                      )}

                      {couponError && (
                        <p className="pricing-details-purchase__message-text pricing-details-purchase__message-text--error">
                          {couponMessage}
                        </p>
                      )}
                    </div>

                    <div className="pricing-details-purchase__actions">
                      <button
                        disabled={!finalAmount || finalAmount <= 0}
                        href="#"
                        style={{ ...subbtn }}
                        className="pricing-details-purchase__buy-button"
                        onClick={handlePayment}
                      >
                        BUY NOW
                      </button>
                      <button
                        style={sharebtn}
                        className="pricing-details-purchase__share-button"
                        onClick={handleShare}
                        aria-label="Share"
                      >
                        <i className="bi bi-share"></i>
                      </button>
                    </div>

                    <div className="pricing-details-purchase__secure">
                      <i className="bi bi-lock"></i>
                      <span>Secure Payment • 100% Safe Checkout</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
        <section className="pricing-details-about-section">
          <div className="pricing-details-about-section__inner">
            <div className="pricing-details-about-section__copy">
              <div className="pricing-details-about-section__copy-sticky">
                <h2 className="pricing-details-about-section__title">About</h2>
                <p className="pricing-details-about-section__text">
                  Complete <strong>10 month pregnancy care package</strong> from day 1 of your pregnancy till delivery of your baby
                </p>
              </div>
            </div>

            <div className="pricing-details-about-section__rail"></div>

            <div className="pricing-details-about-section__cards">
              {aboutFeatures.map((feature) => (
                <article key={feature.title} className="pricing-details-about-card">
                  <div className="pricing-details-about-card__icon-wrap">
                    <img src={feature.icon} className="pricing-details-about-card__icon" alt="" />
                  </div>
                  <div className="pricing-details-about-card__content">
                    <h3 className="pricing-details-about-card__title">{feature.title}</h3>
                    <p className="pricing-details-about-card__description">{feature.description}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </section>
        <section className="pricing-details-specialists-section">
          <div className="pricing-details-specialists-section__inner">
            <div className="pricing-details-specialists-section__header">
              <h2 className="pricing-details-specialists-section__title">Medical Specialists</h2>
              <p className="pricing-details-specialists-section__subtitle">
                Our comprehensive team of healthcare professionals
              </p>
            </div>

            <div className="pricing-details-specialists-grid">
              {[
                "Gynecologist",
                "General Physician",
                "Pediatrician",
                "Yoga Expert",
                "Dietitian",
                "Clinical Psychologist",
                "Breastfeeding Consultant",
                "Meditation Expert",
                "Sonography Centre",
                "Pathology Lab",
              ].map((expertName, index) => (
                <article
                  key={index}
                  className={`pricing-details-specialist-card ${expanded[expertName] ? "pricing-details-specialist-card--expanded" : ""}`}
                  onClick={() => toggleExpand(expertName)}
                >
                  <div className="pricing-details-specialist-card__top">
                    <div className="pricing-details-specialist-card__icon-wrap">
                      <i className="bi bi-person pricing-details-specialist-card__icon"></i>
                    </div>
                    <div className="pricing-details-specialist-card__content">
                      <div className="pricing-details-specialist-card__title-row">
                        <h3 className="pricing-details-specialist-card__title">{expertName}</h3>
                        <span className="pricing-details-specialist-card__arrow">
                          {expanded[expertName] ? "−" : "+"}
                        </span>
                      </div>
                    </div>
                  </div>

                  {expanded[expertName] && (
                    doctorList[expertName]?.length > 0 ? (
                      <ul className="pricing-details-specialist-card__doctor-list">
                        {doctorList[expertName].map((doctor, idx) => (
                          <li key={idx} className="pricing-details-specialist-card__doctor-item">
                            <strong>{doctor.user_name}</strong>
                            <span>{doctor.education}</span>
                            <span>{doctor.experience} years experience</span>
                          </li>
                        ))}
                      </ul>
                    ) : (
                      <p className="pricing-details-specialist-card__empty">
                        {expertName === "Meditation Expert"
                          ? "Meditation services coming soon!"
                          : expertName === "Sonography Centre"
                            ? "Sonography services will be available soon!"
                            : expertName === "Pathology Lab"
                              ? "New Pathology Lab services coming soon!"
                              : "Doctors will be listed soon!"}
                      </p>
                    )
                  )}
                </article>
              ))}
            </div>
          </div>
        </section>


        <section className="pricing-details-schedule-section">
          <div className="pricing-details-schedule-section__inner">
            <div className="pricing-details-schedule-section__header">
              <h2 className="pricing-details-schedule-section__title">Schedule Daily</h2>
              <p className="pricing-details-schedule-section__subtitle">
                Month-by-month breakdown of your comprehensive care plan
              </p>
            </div>

            <div className="pricing-details-schedule-tabs" ref={scheduleTabsRef}>
              {scheduleMonths.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={`pricing-details-schedule-tab ${activeScheduleMonth === index ? "pricing-details-schedule-tab--active" : ""}`}
                  onClick={() => handleScheduleMonthClick(index)}
                >
                  <i className="bi bi-calendar4-week"></i>
                  <span>Month {index + 1}</span>
                </button>
              ))}
            </div>

            <div className="pricing-details-schedule-row" ref={scheduleRowRef}>
              {scheduleMonths.map((content, index) => (
                <div key={index} className="pricing-details-schedule-card-wrapper">
                  <article className="pricing-details-schedule-card">
                    <div className="pricing-details-schedule-card__chrome pricing-details-schedule-card__chrome--left"></div>
                    <div className="pricing-details-schedule-card__chrome pricing-details-schedule-card__chrome--right"></div>

                    <div className="pricing-details-schedule-card__header">
                      <div className="pricing-details-schedule-card__badge">{index + 1}</div>
                      <div>
                        <h3 className="pricing-details-schedule-card__title">Month {index + 1}</h3>
                        <p className="pricing-details-schedule-card__caption">Your care schedule</p>
                      </div>
                    </div>

                    <div className="pricing-details-schedule-card__body">
                      <p>{content}</p>
                    </div>
                  </article>
                </div>
              ))}
            </div>

            <div className="pricing-details-schedule-dots">
              {scheduleMonths.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  className={`pricing-details-schedule-dot ${activeScheduleMonth === index ? "pricing-details-schedule-dot--active" : ""}`}
                  onClick={() => handleScheduleMonthClick(index)}
                  aria-label={`Go to month ${index + 1}`}
                ></button>
              ))}
            </div>
          </div>
        </section>

        <section className="pricing-details-community-section">
          <div className="pricing-details-community-section__inner">
            <h2 className="pricing-details-community-section__title">
              Are you someone, not a mom-to-be?
            </h2>
            <p className="pricing-details-community-section__subtitle">
              Join Our Community
            </p>
            <button
              type="button"
              className="pricing-details-community-section__button"
              onClick={handleSubscribeScroll}
              style={{
                backgroundColor: "#ffab7c",
                backgroundImage: "linear-gradient(180deg, #ffb085 0%, #ffa06f 100%)",
              }}
            >
              <i className="bi bi-lock-fill"></i>
              <span>Subscribe</span>
            </button>
          </div>
        </section>
      </div>
    </>
  );
};

export default Pricingdetails;
